
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 24 24\" id=\"facebook\" ><title>facebook</title><g data-name=\"Layer 2\"><path d=\"M12 24a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-23a11 11 0 1 0 11 11A11 11 0 0 0 12 1z\"/><path d=\"M14.49 12h-1.63v5.81h-2.41V12H9.3v-2h1.15V8.62a2.27 2.27 0 0 1 2.44-2.44h1.79v2h-1.3a.49.49 0 0 0-.51.56V10h1.83z\"/></g></symbol>";
module.exports = sprite.add(image, "facebook");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.svg
// module id = 653
// module chunks = 1474